import { Stack } from 'expo-router';

export default function ChallengeIdLayout() {
  return <Stack screenOptions={{ headerShown: true }} />;
}
